/*@ngInject*/
const FormTemplateSetRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.publishFormTemplates = function (formTemplateIds) {
        var url = '/rest/FormTemplateSet/publishFormTemplates',
            config = {
                params: {
                    resultType: 'brief',
                    uiFormTemplateIds: formTemplateIds
                }
            };

        return this.post(url, {}, config);
    };

    this.publishFormTemplatesByFilterUri = function (filterUri, excludedFormTemplateIds) {
        var url = '/rest/FormTemplateSet/publishFormTemplates',
            config = {
                params: {
                    filterUri: filterUri,
                    resultType: 'brief',
                    excludedFormTemplateIds: excludedFormTemplateIds
                }
            };

        return this.post(url, {}, config);
    };

    this.createTestFormTemplateSet = function () {
        var url = '/rest/FormTemplateSet/createTestFormTemplateSet';
        return this.post(url);
    };

    this.markAllFormTemplatesInProduction = function () {
        var url = '/rest/FormTemplateSet/markCurrentFormTemplateSetInProduction';
        return this.post(url);
    };

};

angular.module('ums.configuration')
    .service('formTemplateSetRepository', FormTemplateSetRepository);
